module.exports = __webpack_public_path__ + "img/top-bg.a57568f7.png";